
    import {Component, Vue} from 'vue-property-decorator'
    import {Getter} from "vuex-class";
    import {addMerchantsGroup, editMerchantsGroup} from "@/api/customerManage";

    interface GroupOption {
        groupId?: string,
        groupName: string,
    }

    @Component({
        name: 'GroupHandle'
    })
    export default class GroupHandle extends Vue {

        labelWidth = '8em';
        formData: GroupOption = {
            groupName: '',
        }

        created () {
            if (this.$isEdit) {
                const data = JSON.parse(this.$route.query.data as string)
                this.formData.groupId = data.groupId
                this.formData.groupName = data.groupName
            }
        }

        addSure() {
            (this.$refs.handleForm as any).validate().then(() => {
                if (this.$isEdit) {
                    editMerchantsGroup(this.formData).then(() => {
                        this.$toast.success({
                            message: '客户分组修改成功！',
                            duration: 1000,
                            onClose: () => {
                                setTimeout(()=>{
                                  this.$router.back()
                                },200)
                            }
                        })
                    })
                } else {
                    addMerchantsGroup(this.formData).then((res) => {
                        this.$toast.success({
                            message: '客户分组新增成功！',
                            duration: 1000,
                            onClose: () => {
                                setTimeout(()=>{
                                  if (this.$route.query.isAdd === '1') {
                                    this.$eventBus.$emit('groupAdd', res.data && res.data.id)
                                  }
                                  this.$router.back()
                                },200)
                            }
                        })
                    })
                }
            });
        }
    }
